import React from 'react'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { I18nextProvider } from 'react-i18next'
import { store } from '../stores'
import i18n from '../i18n'
import ErrorBoundary from './common/ErrorBoundary'
import { ToastProvider } from '../contexts/ToastContext'

type Props = {
  children: React.ReactNode
}

const RootProviders: React.FC<Props> = ({ children }) => (
  <ErrorBoundary>
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <ToastProvider>
          <BrowserRouter>{children}</BrowserRouter>
        </ToastProvider>
      </I18nextProvider>
    </Provider>
  </ErrorBoundary>
)

export default RootProviders
